import {Injectable, Pipe, PipeTransform} from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslocoService } from '@ngneat/transloco';

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'localizedDate', pure: false })
export class LocalizedDatePipe extends DatePipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {
    super(translocoService.getActiveLang());
  }

  override transform = (value: any, format = 'short'): any => {
    var lang = this.translocoService.getActiveLang() === 'en' ? 'en-GB' : this.translocoService.getActiveLang();

    if (lang === 'sr' || lang === 'bs') {
      lang = "sr-Latn";
    }
    if (!value || isNaN(new Date(value).getTime())) {
      return '';
    }

    return super.transform(value, format, undefined, lang);
  };
}
